import { ILotteryItem } from '@bg-shared/interfaces/ILotteryItem';

export const formatBetItems = (items: ILotteryItem[] = []): number[] => {
    if (!items || !items?.length) {
        return null;
    }

    return items.map((item) => item.id);
};
